import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { CacheService } from '../../services/cache/cache.service'
import { Router } from '@angular/router'

@Component({
  selector: 'template-navbar',
  imports: [MatIcon, MatTooltipModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit, OnDestroy {
  constructor(
    private cacheService: CacheService,
    private router: Router,
  ) {}

  @Output() alternarMenu = new EventEmitter<void>()

  currentDateTime: string = ''
  private timer: any
  protected readonly localStorage = localStorage
  ngOnInit() {
    this.updateDateTime()
    this.timer = setInterval(() => {
      this.updateDateTime()
    }, 1000)
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  private updateDateTime(): void {
    const now = new Date()
    this.currentDateTime = now.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }
  nomeUsuario =
    this.localStorage.getItem('nomeUsuario') !== 'undefined' &&
    this.localStorage.getItem('nomeUsuario') !== undefined &&
    this.localStorage.getItem('nomeUsuario') !== null
      ? localStorage.getItem('nomeUsuario')
      : 'Usuário'

  get primeiroNome() {
    return (this.nomeUsuario || 'Usuário').split(' ')[0]
  }

  get iniciais() {
    return (this.nomeUsuario || 'Usuário')
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .join('')
  }

  logout() {
    this.cacheService.clearCache()
    this.router.navigate(['/login'])
  }
}
